window.locales.es = {
	misc: {
		download: 'Descargar',
		height: 'Altura',
		name: 'Nombre',
		width: 'Ancho'
	}
};